import { SCHEDULER } from '@/lib/routes/privateRoutes';

export const EMPTY_STATE_URL_BY_PATH = {
    [SCHEDULER]: '/images/illustrations/empty-states/empty-state-multi-profiles.scheduler.webp'
} as const;

export const DEFAULT_REGULAR_EMPTY_STATE =
    '/images/illustrations/empty-states/empty-state-multi-profiles.png';
